import React from 'react';
import useLoginContext from '../../../hooks/useLoginContext';
import TwoFactorPrompt from './TwoFactorPrompt';
import use2FAPrompt from '../../../hooks/use2FAPrompt';

interface TwoFactorPromptWrapperProps {
  children: React.ReactNode;
}

/**
 * A wrapper component that shows a 2FA setup prompt for users who don't have 2FA enabled
 */
const TwoFactorPromptWrapper: React.FC<TwoFactorPromptWrapperProps> = ({ children }) => {
  const { user, setUser } = useLoginContext();
  const { showPrompt, handleContinue, handleSetupComplete } = use2FAPrompt(user, setUser);

  return (
    <>
      {showPrompt && user && (
        <TwoFactorPrompt
          user={user}
          onContinue={handleContinue}
          onSetupComplete={handleSetupComplete}
        />
      )}
      {children}
    </>
  );
};

export default TwoFactorPromptWrapper;
